export const getResponseBodyEnhanced = async (
  response: Response
): Promise<any> => {
  if (response.status !== 204) {
    try {
      const contentType = response.headers.get("Content-Type");
      if (contentType) {
        const lowerContentType = contentType.toLowerCase();

        // Handle PDF and binary blob types
        if (
          lowerContentType.includes("application/pdf") ||
          lowerContentType.includes("application/octet-stream") ||
          lowerContentType.includes("application/download")
        ) {
          const streamResponse = new Response(response.body);
          return await streamResponse.blob();
        }

        // Existing JSON handling
        const isJSON = lowerContentType.startsWith("application/json");
        if (isJSON && response.json) {
          return await response.json();
        }

        // Fallback to text for other content types
        return await response.text();
      }

      // Fallback if no content type is specified
      return await response.text();
    } catch (error) {
      console.error("Error parsing response body:", error);
    }
  }
  return undefined;
};
